export enum toastPositionEnum {
    topLeft = 'top-left',
    topCenter = 'top-center',
    topRight = 'top-right',
    bottomLeft = 'bottom-left',
    bottomCenter = 'bottom-center',
    bottomRight = 'bottom-right',
}
